<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>Essential Links</h2>
    <ul>
      <li><a href="https://vuejs.org" target="_blank">Core Docs</a></li>
      <li><a href="https://forum.vuejs.org" target="_blank">Forum</a></li>
      <li><a href="https://gitter.im/vuejs/vue" target="_blank">Gitter Chat</a></li>
      <li><a href="https://twitter.com/vuejs" target="_blank">Twitter</a></li>
      <br>
      <li><a href="http://vuejs-templates.github.io/webpack/" target="_blank">Docs for This Template</a></li>
    </ul>
    <h2>Ecosystem</h2>
    <ul>
      <li><a href="http://router.vuejs.org/" target="_blank">vue-router</a></li>
      <li><a href="http://vuex.vuejs.org/" target="_blank">vuex</a></li>
      <li><a href="http://vue-loader.vuejs.org/" target="_blank">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank">awesome-vue</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted(){
    // let self = this
		// let itemUrl = 'http://c.hearst-taiwan.com.tw/2017/beautyawards/route.php?r=item'
		// let voteUrl = 'http://c.hearst-taiwan.com.tw/2017/beautyawards/route.php?r=vote'
		// axios.get(itemUrl)
		// .then((resp) => {
		// 	self.productData = resp.data	
		// })
		// .then(()=>{
		// 	return axios.get(voteUrl)
		// })
		// .then((resp)=>{
		// 	self.currentVote = resp.data
		// 	let obj = self.productData;
		// 	let ids = self.currentVote;
		// 	Object.keys(ids).forEach((key)=>{      
		// 		self.currentVoteData.push(obj[key][ids[key].id]);            
		// 	})      
		// 	console.log(self.currentVoteData)
		// })
		// .catch((err) => {
		// 	console.log(err)
		// })
  }
}

//箭頭函示 一般用法
const test = (a,b) => (a+b)

//只有一個參數 可省略() , =>的右邊 只有一行 js會預設return
const test2 =x => (x*30)

// => 右方使用{} 可寫多行 但是return要自行加上
const tt3 = x => {
  let sum = x+30
  sum = sum + 20
  return sum
}
//箭頭函數＋預設值
const tt4 = (x=15) => {
  let sum = x+30
  sum = sum + 20
  return sum
}
//函式表達式 可都使用箭頭函數替代
const t4 = function(po = 10,url = "sss"){
  let z = po+url
  return z
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?0d547ed7